export default {
  questions: [],
  loadding: false,
  edit: false,
  question_selected: {},
};
